import React, {
  ReactElement,
} from 'react';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import Grid from "@mui/material/Grid";
import {ImageSlider} from "./ImageSlider";
import Box from "@mui/material/Box";
import {Item} from "./Item";
import {PricesTable} from "./PricesTable";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<unknown>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});


export const InformationDialog = ({
                        row,
                                    onClose,
                            }: {
  row: any;
  onClose: ()=>void;
}): ReactElement => {

  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <Dialog
        fullScreen
        open={true}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar sx={{
          position: 'relative',
          background: '#256861',
        }}>
          <Toolbar>

            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Activity - {row?.activity_name}
            </Typography>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Box sx={{
          padding: '10px',
          backgroundColor: '#f9f9f9',
        }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <ImageSlider images={row?.activity?.images} />
            </Grid>

            <Grid item xs={12} lg={3}>
              <Item name={'Description'} value={row?.activity?.description_en} />
            </Grid>
            <Grid item xs={12} lg={3}>
              <Item name={'Includes'} value={row?.activity?.includes} />
            </Grid>
            <Grid item xs={12} lg={3}>
              <Item name={'Availability'} value={row?.activity?.availability} />
            </Grid>
            <Grid item xs={12} lg={3}>
              <Item
                titleWidth={200}
                name={'Activity Full Duration'}
                value={`<p><?xml version="1.0"?><svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 128 128" width="128px" height="128px">    <path d="M 64 13.5 C 36.2 13.5 13.5 36.2 13.5 64 C 13.5 91.8 36.2 114.5 64 114.5 C 91.8 114.5 114.5 91.8 114.5 64 C 114.5 36.2 91.8 13.5 64 13.5 z M 64 19.5 C 88.5 19.5 108.5 39.5 108.5 64 C 108.5 88.5 88.5 108.5 64 108.5 C 39.5 108.5 19.5 88.5 19.5 64 C 19.5 39.5 39.5 19.5 64 19.5 z M 64 31 C 62.3 31 61 32.3 61 34 L 61 58.800781 C 59.2 59.800781 58 61.8 58 64 C 58 67.3 60.7 70 64 70 C 66.2 70 68.199219 68.8 69.199219 67 L 84 67 C 85.7 67 87 65.7 87 64 C 87 62.3 85.7 61 84 61 L 69.199219 61 C 68.699219 60.1 67.9 59.300781 67 58.800781 L 67 34 C 67 32.3 65.7 31 64 31 z"/></svg> <span>${row?.activity?.full_duration}</span></p>`}
                direction={'row'}
              />
            </Grid>
            <Grid item xs={12} lg={3}>
              <Item
                name={'Bus included'}
                type={'checkbox'}
                value={row?.activity?.bus_included}
                direction={'row'}
              />
            </Grid>
            <Grid item xs={12}>
              {row?.show_prices ? (
                <PricesTable rows={row?.activity?.prices} />
              ) : <></>}
            </Grid>

          </Grid>
        </Box>
      </Dialog>
    </>
  );
};
